import InternalRoute from '@components/internal-route.component';
import { NotFoundErrorPage } from '@/components/not-found-error.page';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PERMISSIONS } from '@/constants/permissions';
import { AppShell } from './shell/components/app-shell.component';
import { RequirePermission } from './shell/components/require-permission.component';
// import { DashboardPage } from './dashboard/internal-dashboard.page';
import { InternalItemsPage } from './items/internal-items.page';
import { PreisToolPage } from './preis-tool/preis-tool.page';
import { BusinessPartnersPage } from './business-partners/business-partners.page';
import { BpBrowser } from './business-partners/components/bp-browser.component';
import { BpDetail } from './business-partners/components/bp-detail.component';
import {
  BpDetailEmpty,
  BpOverviewRoute,
  BpOrdersRoute,
  BpContactsRoute,
} from './business-partners/components/bp-detail-routes.component';
import { VerteilerPage } from './business-partners/verteiler.page';
import {
  VerteilerDetail,
  VerteilerDetailEmpty,
} from './business-partners/components/verteiler-detail.component';
import { AdminPage } from './admin/admin.page';
import { SpecificationsPage } from './admin/specifications/specifications.page';
import { SyncTab } from './admin/components/sync-tab.component';
import { SupplierFeedsTab } from './admin/components/supplier-feeds-tab.component';
import { SupplierFeedDetail } from './admin/components/supplier-feed-detail.component';
import {
  OverviewRoute,
  RunsRoute,
  ItemsRoute,
} from './admin/components/supplier-feed-route-tabs.component';
import { RolesPage } from './roles/roles.page';
import { UsersPage } from './users/users.page';
import { EmailBuilderPage } from './email-builder/email-builder.page';
import { SourcingPage } from './sourcing/sourcing.page';
import { SourcingDetailPage } from './sourcing/sourcing-detail.page';
import { CalculatorPage } from './calculator/calculator.page';
import { AnnouncementsPage } from './announcements/announcements.page';

const InternalV2Router = () => (
  <Routes>
    <Route element={<InternalRoute />}>
      <Route element={<AppShell />}>
        {/* Dashboard temporarily disabled — redirect to Items */}
        <Route index element={<Navigate to="items" replace />} />
        {/* <Route
          index
          element={
            <RequirePermission permission={PERMISSIONS.DASHBOARD_VIEW}>
              <DashboardPage />
            </RequirePermission>
          }
        /> */}

        {/* Items */}
        <Route
          element={<RequirePermission permission={PERMISSIONS.ITEMS_VIEW} />}
        >
          <Route path="items" element={<InternalItemsPage />} />
        </Route>

        {/* Preis-Tool */}
        <Route
          element={
            <RequirePermission permission={PERMISSIONS.PREIS_TOOL_VIEW} />
          }
        >
          <Route path="preis-tool" element={<PreisToolPage />} />
        </Route>

        {/* Business Partners */}
        <Route
          element={
            <RequirePermission permission={PERMISSIONS.BUSINESS_PARTNERS_VIEW} />
          }
        >
          <Route path="business-partners" element={<BusinessPartnersPage />}>
            <Route element={<BpBrowser />}>
              <Route index element={<BpDetailEmpty />} />
              <Route path=":bpId" element={<BpDetail />}>
                <Route index element={<BpOverviewRoute />} />
                <Route path="auftraege" element={<BpOrdersRoute />} />
                <Route
                  path="auftraege/:docEntry"
                  element={<BpOrdersRoute />}
                />
                <Route path="kontakte" element={<BpContactsRoute />} />
                <Route
                  path="kontakte/:contactId"
                  element={<BpContactsRoute />}
                />
              </Route>
            </Route>
            <Route path="verteiler" element={<VerteilerPage />}>
              <Route index element={<VerteilerDetailEmpty />} />
              <Route path=":listId" element={<VerteilerDetail />} />
            </Route>
          </Route>
        </Route>

        {/* Sourcing */}
        <Route
          element={<RequirePermission permission={PERMISSIONS.SOURCING_VIEW} />}
        >
          <Route path="sourcing" element={<SourcingPage />} />
          <Route path="sourcing/:id" element={<SourcingDetailPage />} />
        </Route>

        {/* Admin — Benutzer + Rollen are secondary-nav tabs inside it;
            each tab keeps its own permission gate. */}
        <Route path="admin" element={<AdminPage />}>
          <Route
            element={<RequirePermission permission={PERMISSIONS.ADMIN_VIEW} />}
          >
            <Route index element={<SyncTab />} />
          </Route>
          <Route
            element={
              <RequirePermission
                permission={PERMISSIONS.SUPPLIER_PRICE_LISTS_VIEW}
              />
            }
          >
            <Route
              path="supplier-price-lists"
              element={<SupplierFeedsTab />}
            />
            <Route
              path="supplier-price-lists/:feedId"
              element={<SupplierFeedDetail />}
            >
              <Route index element={<OverviewRoute />} />
              <Route path="runs" element={<RunsRoute />} />
              <Route path="items" element={<ItemsRoute />} />
            </Route>
          </Route>
          <Route
            element={
              <RequirePermission
                permission={PERMISSIONS.SPECIFICATIONS_VIEW}
              />
            }
          >
            <Route path="specifications" element={<SpecificationsPage />} />
          </Route>
          <Route
            element={<RequirePermission permission={PERMISSIONS.USERS_MANAGE} />}
          >
            <Route path="users" element={<UsersPage />} />
          </Route>
          <Route
            element={<RequirePermission permission={PERMISSIONS.ROLES_MANAGE} />}
          >
            <Route path="roles" element={<RolesPage />} />
          </Route>
          <Route
            element={
              <RequirePermission
                permission={PERMISSIONS.ANNOUNCEMENTS_MANAGE}
              />
            }
          >
            <Route path="announcements" element={<AnnouncementsPage />} />
          </Route>
        </Route>

        {/* Email Builder */}
        <Route
          element={
            <RequirePermission permission={PERMISSIONS.EMAIL_BUILDER_VIEW} />
          }
        >
          <Route path="email-builder" element={<EmailBuilderPage />} />
        </Route>

        {/* Rechner — pricing calculators */}
        <Route
          element={
            <RequirePermission permission={PERMISSIONS.PREIS_TOOL_VIEW} />
          }
        >
          <Route path="calculator" element={<CalculatorPage />} />
        </Route>

        {/* Legacy paths — Benutzer + Rollen moved into the Admin section */}
        <Route path="users" element={<Navigate to="/i/admin/users" replace />} />
        <Route path="roles" element={<Navigate to="/i/admin/roles" replace />} />

        {/* Pages added incrementally — 404 catch-all for the rest */}
        <Route path="*" element={<NotFoundErrorPage />} />
      </Route>
    </Route>
  </Routes>
);

export default InternalV2Router;
